<!-- Pegada al borde derecho, a media altura: en las 22 rutas del panel no hay ningún botón de
     acción ahí. Se esconde mientras el propio diálogo está abierto. -->
<button
  type="button"
  class="bug-tab"
  *ngIf="!open"
  (click)="launch('tab')"
  [disabled]="preparing"
  [attr.aria-label]="'Reportar un problema (' + shortcut + ')'"
  [title]="'Reportar un problema · ' + shortcut">
  <i class="fa-solid" [class.fa-bug]="!preparing" [class.fa-spinner]="preparing" [class.fa-spin]="preparing"></i>
  <span class="bug-tab-text">Reportar un problema</span>
</button>

<app-bug-report-dialog [(visible)]="open" *ngIf="open"></app-bug-report-dialog>
